const setAudienceId = (state, payload) => {
  state.audienceId = payload
}

export default {
  setAudienceId,
}
